import * as Scrivito from "scrivito";
import classNames from "classnames";
import { isLiv } from "^/utils/isLiv";
import LanguageSwitchItem from "./LanguageSwitchItem";

function LanguageSwitch() {
  const currentPage = Scrivito.currentPage();
  if (!currentPage) {
    return null;
  }
  const homepageVersions = {};
  Scrivito.Obj.onAllSites()
    .where("_objClass", "equals", "Homepage")
    .take()
    .forEach((obj) => {
      const language = obj.language()?.toUpperCase() || "DE";
      homepageVersions[language] = obj;
    });
  if (Object.keys(homepageVersions).length === 0) {
    return null;
  }

  const pageVersions = {};
  currentPage.versionsOnAllSites().forEach((item) => {
    pageVersions[item.language()?.toUpperCase() || "DE"] = item;
  });

  const currentLanguage = currentPage.language()?.toUpperCase() || "DE";

  const languages = isLiv(currentPage) ? ["DE", "EN", "ES"] : ["DE", "EN"];

  return (
    <div className="d-flex mt-2px language-switch">
      {languages.map((lang, index) => {
        const classes = classNames(["px-2 py-1"], {
          "fw-bolder": currentLanguage !== lang,
        });
        return (
          <LanguageSwitchItem
            key={`lang${index}`}
            destination={pageVersions[lang]}
            className={classes}
            language={lang}
            currentPage={currentPage}
          />
        );
      })}
    </div>
  );
}

export default Scrivito.connect(LanguageSwitch);
